import { render } from "./VillasTable.vue?vue&type=template&id=ae42b84e&scoped=true"
import script from "./VillasTable.vue?vue&type=script&lang=js"
export * from "./VillasTable.vue?vue&type=script&lang=js"

import "./VillasTable.vue?vue&type=style&index=0&id=ae42b84e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae42b84e"

export default script